import React, { createContext, useContext, useState, useEffect } from 'react';

const CartContext = createContext();
const STORAGE_KEY = 'offf_cart';

export function useCart() {
    return useContext(CartContext);
}

export function CartProvider({ children }) {
    const [cartItems, setCartItems] = useState(() => {
        try {
            const saved = localStorage.getItem(STORAGE_KEY);
            return saved ? JSON.parse(saved) : [];
        } catch {
            return [];
        }
    });

    useEffect(() => {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(cartItems));
    }, [cartItems]);

    const cartCount = cartItems.reduce((sum, item) => sum + item.quantity, 0);

    const addToCart = (item) => {
        setCartItems((prev) => {
            const existing = prev.find(
                (i) =>
                    i.type === item.type &&
                    i.productId === item.productId &&
                    i.roastLevel === item.roastLevel &&
                    i.originType === item.originType &&
                    i.region === item.region &&
                    i.color === item.color &&
                    i.size === item.size
            );
            if (existing) {
                return prev.map((i) =>
                    i === existing ? { ...i, quantity: i.quantity + item.quantity } : i
                );
            }
            return [...prev, item];
        });
    };

    const removeFromCart = (index) => {
        setCartItems((prev) => prev.filter((_, i) => i !== index));
    };

    const updateQuantity = (index, newQty) => {
        if (newQty < 1) return;
        setCartItems((prev) =>
            prev.map((item, i) => (i === index ? { ...item, quantity: newQty } : item))
        );
    };

    const clearCart = () => {
        setCartItems([]);
    };

    const [isDrawerOpen, setIsDrawerOpen] = useState(false);
    const openDrawer = () => setIsDrawerOpen(true);
    const closeDrawer = () => setIsDrawerOpen(false);

    const value = { cartItems, cartCount, addToCart, removeFromCart, updateQuantity, clearCart, isDrawerOpen, openDrawer, closeDrawer };

    return (
        <CartContext.Provider value={value}>
            {children}
        </CartContext.Provider>
    );
}
